// Generated by OrchestKit Claude Plugin
// Created: 2026-09-11

/**
 * Types et outils communs aux écrans de stock : réceptions et transferts.
 */

export interface Reception {
  id: string;
  numero: string;
  boutique: string;
  fournisseur: string;
  reference_fournisseur: string | null;
  date_reception: string;
  enregistree_le: string;
  saisie_par: string;
  lignes: number;
  quantite_totale: number;
  /** Absente pour qui ne voit pas les coûts — RG-143. */
  valeur?: number;
}

export interface DetailReception extends Omit<Reception, 'lignes'> {
  frais_accessoires: number;
  lignes: {
    produit_id: string;
    reference: string;
    designation: string;
    quantite: number;
    /** Ces trois champs sont absents pour qui ne voit pas les coûts. */
    cout_unitaire?: number;
    frais_repartis?: number;
    cout_complet?: number;
  }[];
}

export interface Transfert {
  id: string;
  numero: string;
  statut: 'EXPEDIE' | 'RECU';
  motif: string | null;
  source_id: string;
  source: string;
  source_nom: string;
  destination_id: string;
  destination: string;
  destination_nom: string;
  expedie_le: string;
  expedie_par: string;
  recu_le: string | null;
  recu_par: string | null;
  /** Vrai si l'une de MES boutiques est la destination d'un envoi en route. */
  a_recevoir: boolean;
}

export interface LigneTransfert extends Transfert {
  lignes: number;
  quantite_expediee: number;
  quantite_recue: number | null;
}

export interface DetailTransfert extends Transfert {
  lignes: {
    produit_id: string;
    reference: string;
    designation: string;
    quantite_expediee: number;
    quantite_recue: number | null;
    ecart: number | null;
  }[];
}

export interface LigneStock {
  produit_id: string;
  reference: string;
  designation: string;
  boutique_id: string;
  boutique: string;
  quantite: number;
  /** Seuil effectif : surcharge de la boutique, sinon commun. Absent = aucune alerte. */
  seuil: number | null;
  sous_seuil: boolean;
  /** Ces deux champs n'arrivent qu'à qui voit les coûts — RG-143. */
  cout_moyen?: number;
  valeur?: number;
}

export interface Mouvement {
  id: string;
  type: string;
  quantite: number;
  horodatage_serveur: string;
  produit_id: string;
  boutique: string;
  document_type: string;
  document_numero: string | null;
  utilisateur: string;
  cout_unitaire?: number;
}

/** Longueur minimale du motif d'un écart de réception — RG-053, comme le serveur. */
export const MOTIF_ECART_MIN = 10;

/** Date du jour, AAAA-MM-JJ : le serveur refuse une date de réception future. */
export function aujourdhui(): string {
  return new Date().toISOString().slice(0, 10);
}

/** Une date AAAA-MM-JJ, affichée sans décalage de fuseau. */
export function dateSimple(valeur: string): string {
  return new Date(`${valeur}T00:00:00Z`).toLocaleDateString('fr-FR', { timeZone: 'UTC' });
}
